import { Close } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import fileUploadService from "../../../../../services/fileUpload";

import IMAGES from "../../../../../constants/images";
import styles from "./FileUploadButton.module.scss";
import { getFileName, getTimeStamp } from "../../../../../utils/helper";
import { DOCUMENTS, LABEL, _URL } from "../../../../../constants/forms";
import useAppStore from "../../../../../states/zustand/appStore";
import { logger } from "../../../../../utils/logger";

interface IProps {
  name: string;
  label?: string;
  fileName?: string;
  className?: string;
  index?: number;
  parentIndex: number;
  gridName?: string;
  showError?: boolean;
  [x: string]: any;
}

const FileUploadButton: FC<IProps> = (props) => {
  const {
    name,
    label = "Upload",
    fileName = "File",
    className,
    index = 0,
    gridName,
    showError = true,
    parentIndex,
    ...rest
  } = props;

  const {
    values,
    setFieldValue,
    validateForm,
    errors,
    setFieldError,
    setErrors,
  } = useFormikContext<FormikValues>();

  const [uploadedFileName, setUploadedFileName] = useState(fileName);
  const { setLoader } = useAppStore();

  const checkFormValidation = (modifiedValues: FormikValues) => {
    const prevErrors = { ...errors };
    validateForm(modifiedValues).then((res) => {
      if (res[name]) {
        setFieldError(name, JSON.stringify(res[name]));
      }
    });
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.target.files) return;

    try {
      setLoader(true);

      const imageUrl = await fileUploadService.upload(
        e.target.files,
        `${getTimeStamp()}-${values[name][parentIndex][DOCUMENTS][index][LABEL]}`
      );
      setLoader(false);

      if (gridName) {
        const projects = [...values[name]];
        projects[parentIndex].documents[index][gridName] = imageUrl.data;
        setFieldValue(name, projects);
        // checkFormValidation({ ...values, [name]: imageUrl.data });

        setUploadedFileName(getFileName(imageUrl.data));
        return;
      }

      // setFieldValue(name, imageUrl.data);
      toast.success("File uploaded successfully");
      // checkFormValidation({ ...values, [name]: imageUrl.data });
    } catch (err: any) {
      logger.log({ err });
      setLoader(false);
      toast.error("Cannot upload a file");
    }
  };

  const handleFileDelete = async () => {
    try{
    setLoader(true);
    await fileUploadService.deleteFile(values[name][parentIndex][DOCUMENTS][index][_URL]);
    setLoader(false)
    if (gridName) {
      const projects = [...values[name]];
      projects[parentIndex].documents[index][gridName] = "";
      setFieldValue(name, projects);
      // checkFormValidation({ ...values, [name]: prev });
      return;
    } else {
      setFieldValue(name, "");
      // checkFormValidation({ ...values, [name]: "" });
    }} catch (error) {
      setLoader(false);
      logger.error(error);
    }
  };

  const isShowUploadButton = (): boolean => {
    if (gridName) {
      return !values[name][parentIndex].documents[index][gridName];
    } else {
      return !values[name][parentIndex].documents;
    }
  };

  return (
    <>
      <Box
        className={`d-flex align-items-center ${
          className ? className : "mg-t-16"
        }`}
      >
        {isShowUploadButton() && (
          <Box className="upload-box d-flex align-items-center justify-content-center mg-r-16">
            <label>
              <i className="icon-upload-cloud mg-r-10"></i>
              <Typography
                className="mg-r-6 font-size-sm font-weight-medium"
                variant={"subtitle1"}
                component={"span"}
              >
                {label}
              </Typography>
            </label>
            <div className="hidden-input">
              <input
                type="file"
                // accept="image/png, image/gif, image/jpeg, application/pdf"
                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleFileUpload(e)
                }
                className="form-control"
                name={name}
                // onClick={(e) => { e.preventDefault(); }}
                {...rest}
              />
            </div>
          </Box>
        )}

        {!isShowUploadButton() && (
          <div className={styles.uploaded}>
            <div className="d-flex gap-xs">
              <img src={IMAGES.Clipboard} alt="" />{" "}
              <span>{uploadedFileName}</span>
            </div>
            <Button type="button" onClick={handleFileDelete}>
              <Close
                sx={{
                  color: "#9FA2B4",
                }}
              />
            </Button>
          </div>
        )}
      </Box>
      {showError && (
        <Box>
          <ErrorMessage
            name={name}
            render={(msg) => (
              <span className="text-danger font-size-sm">{msg}</span>
            )}
          />
        </Box>
      )}
    </>
  );
};

export default FileUploadButton;
